<template>
    <div></div>
</template>

<script setup lang="ts">
import { watch, onUnmounted, ref } from 'vue'
import type { PhotoDetail } from '@/types'
import { usePhotos } from '@/composables/usePhotos'

const props = defineProps<{
    photoDetails: PhotoDetail[]
    map: any
}>()

const imageOverlays = ref<any[]>([])
const { parseCamPolygonCorners, createCustomImageOverlay } = usePhotos()

// Función principal para cargar los overlays del mosaico
function loadMosaicOverlays() {
    try {
        if (!props.photoDetails || props.photoDetails.length === 0) {
            console.log('No hay detalles de fotos para cargar')
            return
        }

        // Limpiar overlays anteriores
        clearOverlays()

        console.log(`Cargando ${props.photoDetails.length} overlays de fotos`)

        props.photoDetails.forEach((photoDetail) => {
            const corners = parseCamPolygonCorners(photoDetail.cam_polygon)
            if (!corners || corners.length < 4) {
                console.warn(`No se pudieron obtener las esquinas para photo_id: ${photoDetail.photo_id}`)
                return
            }

            let imageUrl = ''
            if (photoDetail.filename_jpg) {
                imageUrl = '/fserver/documents' + photoDetail.filename_jpg
            }

            if (!imageUrl) {
                console.warn(`No se pudo obtener la URL de la imagen para photo_id: ${photoDetail.photo_id}`)
                return
            }

            try {
                const overlay = createCustomImageOverlay(corners, imageUrl)
                if (overlay && props.map?.leafletObject) {
                    overlay.addTo(props.map.leafletObject)
                    imageOverlays.value.push(overlay)
                    console.log(`Overlay agregado para photo_id: ${photoDetail.photo_id}`)
                }
            } catch (overlayError) {
                console.error(`Error creando overlay para photo_id ${photoDetail.photo_id}:`, overlayError)
            }
        })

        console.log(`Total de overlays cargados: ${imageOverlays.value.length}`)

    } catch (error) {
        console.error('Error en loadMosaicOverlays:', error)
    }
}

// Función para limpiar todos los overlays
function clearOverlays() {
    if (imageOverlays.value.length > 0 && props.map?.leafletObject) {
        imageOverlays.value.forEach(overlay => {
            props.map.leafletObject.removeLayer(overlay)
        })
        imageOverlays.value = []
        console.log('Overlays eliminados')
    }
}

// Watch para cuando cambian los detalles de las fotos
watch(
    () => props.photoDetails,
    (newPhotoDetails) => {
        if (newPhotoDetails && newPhotoDetails.length > 0) {
            loadMosaicOverlays()
        } else {
            clearOverlays()
        }
    },
    { immediate: true, deep: true }
)

// Watch para cuando cambia el mapa
watch(
    () => props.map,
    (newMap) => {
        if (newMap?.leafletObject && props.photoDetails && props.photoDetails.length > 0) {
            loadMosaicOverlays()
        }
    }
)

// Limpiar al desmontar
onUnmounted(() => {
    clearOverlays()
})
</script>

<style scoped>
:deep(.custom-image-overlay) {
    transition: opacity 0.2s ease;
}

:deep(.custom-image-overlay:hover) {
    opacity: 1 !important;
}
</style>
